import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { styled } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import DialogName from "./DialogName";
import {
  getTerminateList,
  getTerminateReviewer,
} from "../../../../../actions/offBoarding";
import DialogReview from "./DialogReview";

const StyledWrapBranch = styled("div")({
  marginBottom: 36,
  "& .wrap-branch-top": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 30,
    "& .MuiTypography-body2": {
      margin: 0,
    },
  },
  "& .branch-scroll": {
    height: 280,
    overflow: "auto",
  },
  "& .action": {
    textAlign: "right",
    "& .fal": {
      fontSize: 18,
    },
  },
  "& .address": {
    fontWeight: 600,
    fontSize: 18,
  },
  "& .contact": {
    "& .fal": {
      marginRight: 8,
    },
  },
});

const TerminateList = () => {
  const dispatch = useDispatch();
  const { result: terminateReviewer } = useSelector(
    (state) => state.terminateReviewer
  );
  const { result: terminateList } = useSelector((state) => state.terminateList);
  const [openDialog, setopenDialog] = useState(false);
  const [formData, setFormData] = useState(null);
  const [typeDialog, setTypeDialog] = useState("Add");
  const [reload, setreload] = useState();

  useEffect(() => {
    dispatch(getTerminateList());
    dispatch(getTerminateReviewer());
  }, [reload]);

  const handleOpenDialog = (type, formData) => {
    setTypeDialog(type);
    setopenDialog(true);
    if (formData) {
      setFormData(formData);
    }
  };

  const handleClose = () => {
    setopenDialog(false);
    if (reload === 1) setreload(2);
    else setreload(1);
    setFormData(null);
  };

  return (
    <div>
      <StyledWrapBranch>
        <div className="wrap-branch-top">
          <div>
            <ButtonBlue
              style={{ marginRight: 8 }}
              size="small"
              variant="contained"
              onClick={() => handleOpenDialog("AddList")}
            >
              เพิ่มรายการ
            </ButtonBlue>
            <ButtonBlue
              style={{ marginRight: 8 }}
              size="small"
              variant="contained"
              onClick={() => handleOpenDialog("AddReview")}
            >
              เพิ่มผู้ตรวจสอบ
            </ButtonBlue>
          </div>
        </div>
        {terminateList && terminateList.length > 0 ? (
          <div>
            {terminateList.map((row, index) => (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ width: "90%", flexShrink: 0 }}>
                    {row.name}
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    ผู้ตรวจสอบ
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {terminateReviewer && terminateReviewer.length > 0 ? (
                    terminateReviewer.filter(
                      (review) => review.idTerminateList === row.idTerminateList
                    ).length > 0 ? (
                      terminateReviewer.map((review) => {
                        if (review.idTerminateList === row.idTerminateList)
                          return (
                            <Typography>
                              {review.firstname_TH +
                                "   " +
                                review.lastname_TH +
                                "   (" +
                                review.departmentName +
                                ")"}
                            </Typography>
                          );
                      })
                    ) : (
                      <Typography>ไม่มีผู้ตรวจสอบ </Typography>
                    )
                  ) : (
                    <Typography>ไม่มีผู้ตรวจสอบ </Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        ) : (
          "ไม่มีรายการลาออก"
        )}
      </StyledWrapBranch>
      {openDialog && typeDialog !== "AddReview" && (
        <DialogName
          mode={typeDialog}
          open={openDialog}
          data={formData}
          handleClose={handleClose}
        />
      )}
      {openDialog && typeDialog === "AddReview" && (
        <DialogReview open={openDialog} handleClose={handleClose} />
      )}
    </div>
  );
};

export default TerminateList;
